export default "__VITE_ASSET__WXYxUhVb__"